module.exports = __webpack_public_path__ + "img/nav.2ce03cd1.png";